const AppMutationTypes = {
    setSettings: "setSettings",
    setValidationRules: "setValidationRules",
    setPromotion: "setPromotion",
    setCheckout: "setCheckout",
    setOrder: "setOrder",
    setDocumentTitleAndColor: "setDocumentTitleAndColor"
};

export default AppMutationTypes;
